import { Container, ContainerContentFull, ContainerContentNarrow } from '../../../../shared/styles/container'
import Layout from '../../components/global/Layout'
import Seo from '../../components/global/Seo'
import { ExtendedNewsletterBlock } from '../../components/ueber-uns/ExtendedNewsletterBlock'
import { HeroIntro } from '../../components/ueber-uns/HeroIntro'
import { TeamSection } from '../../components/ueber-uns/Team'
import { TopicsTablist } from '../../components/ueber-uns/TopicsTablist'
import { theme } from '../../styles/theme'

const AboutUsPage = () => {

    const title = 'Über uns';
    const description = 'Das STELL-MICH-EIN hatte seine Geburtsstunde im Berliner KommunikationsFORUM e.V. Seit 2012 wurde das damals einzige Speed-Recruiting der Kommunikationsbranche zu unterschiedlichen Events und Anlässen von wechselnden Teams organisiert. So waren wir zu Gast auf ADC Kongressen, Hochschultagen und Messen.';

    return (
        <>
            <Seo title={title} description={description} />
            <Layout preview={false}>
                <Container>
                    <ContainerContentFull>
                        <HeroIntro />
                    </ContainerContentFull>
                    <ContainerContentNarrow>
                        <ExtendedNewsletterBlock />
                    </ContainerContentNarrow>
                </Container>
                <Container backgroundColor={theme.colors.lightBg}>
                    <ContainerContentFull>
                        <TopicsTablist />
                        <TeamSection />
                    </ContainerContentFull>
                </Container>
            </Layout>
        </>
    )
}

export default AboutUsPage;
